import { PaymentDeadlineStatus } from "../enums/payment-deadline-status.enum";

export class internDetails {
  Identifier: number = 0;
  LastName: string = null;
  FirstName: string = null;
  StreetAddress: string = null;
  City: string = null;
  State: string = null;
  ZipCode: string = null;
  Phone: string = null;
  Email: string = null;
  AdmissionDate: string = null;
  CertificateAreas: string[];
  RuleSet: string = null;
  MobilePhone: string = null;
  AltEmail: string = null;
  StateIdentifier: string = null;
  profileId: number = 0;
  profileState: string = null;
  stateId: number = 0;
  MentorAssignedEmailAddress: string = null;
  MentorAssignedFirstName: string = null;
  MentorAssignedLastName: string = null;
  MentorAssignedPhoneNumber: string = null;
  MentorAssignedStateLicenseId: string = null;
  ProgramPaymentDeadline: string = null;
  ProgramPaymentDeadlineStatus: PaymentDeadlineStatus = PaymentDeadlineStatus.Undetermined;
  companyId: number = 0;
  programId: number = 0;
}
